
import BadgeReportContainer from "../../../Component/Application/badgeReporting/badge-report-container";

const BadgeReportingPage = () => {

    return (
        <div className="page-body">
            <BadgeReportContainer />    
        </div>
    );

};

export default BadgeReportingPage;